module.exports = __webpack_public_path__ + "static/media/p6.5fa23fe7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/personalization/images/urbanhipster/p6.jpg
// module id = 2940
// module chunks = 0